<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3 13V6.53518L8 3.20185L13 6.53518V13H3Z"
    stroke="currentColor"
    stroke-width="2"
  />
</svg>
